module.exports = __webpack_public_path__ + "img/401-95fc3b.png";